export const revenueScenarios = [
  { customers: '10 customers', revenue: '$1 million' },
  { customers: '100 customers', revenue: '$10 million' },
]

export const growthSteps = [
  'Win initial deployments with research institutions and knowledge-intensive organizations.',
  'Turn repeatable components into a configurable platform.',
  'Expand successful deployments to additional teams and use cases.',
  'Add capabilities and support through recurring contracts.',
  'Pursue larger enterprise and government opportunities as the product and delivery model mature.',
]

export const growthMeasures = [
  'Customer outcomes',
  'Implementation time',
  'Annual contract value',
  'Renewals',
  'Expansion within existing accounts',
]

export const investmentUses = [
  'Product engineering',
  'Domain-specific pilots',
  'Validation of customer outcomes',
  'Security and deployment capabilities',
  'The team to deliver and support repeatable implementations',
]
